import { render, staticRenderFns } from "./MessageInactiveInboxViewSidebar.vue?vue&type=template&id=53494845&scoped=true"
import script from "./MessageInactiveInboxViewSidebar.vue?vue&type=script&lang=js"
export * from "./MessageInactiveInboxViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./MessageInactiveInboxViewSidebar.vue?vue&type=style&index=0&id=53494845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53494845",
  null
  
)

export default component.exports